var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.63 16.7685V12.4485C20.63 11.7687 20.0798 11.2185 19.4 11.2185C18.7202 11.2185 18.17 11.7687 18.17 12.4485V16.7685C18.17 17.4483 18.7202 17.9985 19.4 17.9985C20.0798 17.9985 20.63 17.4483 20.63 16.7685Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.31 16.7686V8.93864C16.31 8.25886 15.7598 7.70864 15.08 7.70864C14.4002 7.70864 13.85 8.25886 13.85 8.93864V16.7686C13.85 17.4484 14.4002 17.9986 15.08 17.9986C15.7598 17.9986 16.31 17.4484 16.31 16.7686Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.99 16.7685V12.4485C11.99 11.7687 11.4398 11.2185 10.76 11.2185C10.0802 11.2185 9.53 11.7687 9.53 12.4485V16.7685C9.53 17.4483 10.0802 17.9985 10.76 17.9985C11.4398 17.9985 11.99 17.4483 11.99 16.7685Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56 19.8586H9.41C8.4487 19.8586 7.67 19.0799 7.67 18.1186V6.50859C7.67 5.8288 7.11978 5.27859 6.44 5.27859C5.76021 5.27859 5.21 5.8288 5.21 6.50859V18.1186C5.21 19.2321 5.65297 20.3007 6.44046 21.088C7.22792 21.8753 8.29648 22.3185 9.40986 22.3185H21.5599C22.2396 22.3185 22.7899 21.7682 22.7899 21.0885C22.7899 20.4087 22.2398 19.8586 21.56 19.8586Z",
    fill: "currentcolor",
    stroke: "currentcolor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.11451fe8c70d0645b923aa4a88466294.svg";
export { ForwardRef as ReactComponent };